// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AiIconComponent = /* @__PURE__ */ forwardRef<SVGSVGElement, SvgIconProps>(
  (props: SvgIconProps, forwardedRef): JSX.Element => {
    return (
      <SvgIcon data-iconname="AiIcon" ref={forwardedRef} {...props}>
        <path d="m13.25 3 .571 3.04a3 3 0 0 0 2.234 2.36L18.5 9l-2.445.6a3 3 0 0 0-2.234 2.36L13.25 15l-.571-3.04a3 3 0 0 0-2.234-2.36L8 9l2.445-.6a3 3 0 0 0 2.234-2.36z" />
        <path d="m5.25 3 .221 1.188A3 3 0 0 0 7.7 6.552L8.5 6.75 7.699 6.948a3 3 0 0 0-2.228 2.364L5.25 10.5 5.029 9.312A3 3 0 0 0 2.8 6.948L2 6.75l.801-.198a3 3 0 0 0 2.228-2.364z" />
        <path d="m7.75 10.5.221 1.188a3 3 0 0 0 2.228 2.364L11 14.25l-.801.198a3 3 0 0 0-2.228 2.363L7.75 18l-.221-1.189A3 3 0 0 0 5.3 14.449L4.5 14.25l.801-.198a3 3 0 0 0 2.228-2.363z" />
      </SvgIcon>
    );
  },
);

/**
 * @public
 */
export const AiIcon = /* @__PURE__ */ Object.assign(AiIconComponent, {
  displayName: 'AiIcon',
});
